export const base_url = "https://62.12.113.90:8181/maliplusEcom/links/POS/"

// export const base_url = "http://localhost:8000/api/"



//Common 
//login 
export const Loginurl = base_url + "login"
//register
export const Registerurl = base_url + "register"
//change pass
export const Changepasswordurl = base_url + "changepassword"


//Users
//update user info
export const Updateuserinfourl = base_url + "updateuserinfo"
//update profilepic url
export const Updateprofilepicurl = base_url + "updateprofilepic"

//order
//fetch my orders 
export const Fetchmyordersurl = base_url + "fetchmyorders"






